import React, { forwardRef, RefAttributes } from 'react'

import { Container } from './styles'

interface StateProps {
  close(): void
  fontSize?: number
  setFontSize(fontSize: number): void
}

const RangerSlider: React.FC<RefAttributes<HTMLDivElement> & StateProps> = forwardRef(
  ({ fontSize = 1, setFontSize }, ref) => {
    return (
      <Container ref={ref}>
        <div className="sliderWrapper">
          <h6>Aa</h6>
          <input
            onChange={(event) => setFontSize(Number(event.target.value))}
            defaultValue={fontSize}
            id="slider"
            className="sliderContainer"
            type="range"
            min="1"
            max="3"
            step={0.5}
            style={{ touchAction: 'none', msTouchAction: 'none' }}
          />
          <h4>Aa</h4>
        </div>
      </Container>
    )
  }
)

RangerSlider.displayName = 'RangerSlider'

export default RangerSlider
